<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Bookmarks Container -->
      <bookmarks class="hide" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale class="hide" />
      <dark-toggler class="d-none d-lg-block hide" />
      <search-bar />
      <chat-tool />
      <support-dropdown class="hide" />
      <notification-dropdown class="hide" />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import SupportDropdown from './components/SupportDropdown.vue'
import ChatTool from './ChatTool.vue'

export default {
  components: {
    BLink,
    ChatTool,
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    NotificationDropdown,
    UserDropdown,
    DarkToggler,
    SupportDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
